import {
  BlogPostModel,
  BlogTagModel,
} from 'src/app/core/model/object/blog-model';
import { ActivityModel } from './../object/blog-model';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
export class BlogTokenRefreshResponse {
  constructor(public success: boolean, public token: string) {}
}

export class BlogUserTokenModel {
  constructor(public success: boolean, public token: string) {}
}

export class BlogGetUserResponseModel {
  constructor(public success: boolean, public data: JSON | BlogUserModel) {}
}

export class BlogGetUser2ResponseModel {
  constructor(
    public success: boolean,
    public followees: number,
    public followers: number,
    public relations: JSON,
    public user: BlogUserModel
  ) {}
}

export class BlogListResponseModel {
  constructor(
    public success: boolean,
    public data: JSON,
    public count?: number
  ) {}
}

export class UserFolloweesResponseModel {
  constructor(
    public success: boolean,
    public count: number,
    public followees: BlogUserModel[]
  ) {}
}

export class UserFollowersResponseModel {
  constructor(
    public success: boolean,
    public count: number,
    public followers: BlogUserModel[]
  ) {}
}

export class BlogSearchUserResponseModel {
  constructor(public success: boolean, public users: BlogUserModel[]) {}
}

export class BlogSearchTagAndUserResponseModel {
  constructor(
    public success: boolean,
    public users: BlogUserModel[],
    public tags: BlogTagModel[]
  ) {}
}

export class BlogSearchTagResponseModel {
  constructor(public success: boolean, public data: BlogTagModel[]) {}
}

export class BlogFeedResponseModel {
  constructor(
    public success: boolean,
    public posts: JSON,
    public count?: number
  ) {}
}

export class BlogPostResponseModel {
  constructor(public success: boolean, public data: BlogPostModel) {}
}

export class UserSuggestionsResponseModel {
  constructor(public success: boolean, public suggestions: BlogUserModel[]) {}
}

export class UserBlocksResponseModel {
  constructor(public success: boolean, public blockedUsers: BlogUserModel[]) {}
}

export class UserBlockResponseModel {
  constructor(public success: boolean) {}
}

export class BlogFollowResponseModel {
  constructor(public success: boolean, public message: string) {}
}

export class BlogActivityResponseModel {
  constructor(
    public success: boolean,
    public count: number,
    public activities: ActivityModel[]
  ) {}
}

export class BlogActivityCountResponseModel {
  constructor(public success: boolean, public unreadCount: number) {}
}

export class GetFollowRequestsResponseModel {
  constructor(
    public success: boolean,
    public followers: BlogUserModel[],
    public count: number
  ) {}
}

export class BlogLikeResponseModel {
  constructor(public success: boolean) {}
}

export class BlogDeletePostResponseModel {
  constructor(public success: boolean) {}
}

export class BlogCreateCommentOrReplyResponseModel {
  constructor(
    public success: boolean,
    public message: string,
    public data: JSON
  ) {}
}

export class BlogDeleteCommentResponseModel {
  constructor(public success: boolean) {}
}

export class BlogReportResponseModel {
  constructor(public success: boolean) {}
}

export class BlogEditProfileResponseModel {
  constructor(
    public success: boolean,
    public message: string,
    public user: BlogUserModel
  ) {}
}

export class BlogValidateUsernameResponseModel {
  constructor(public success: boolean, public message: string) {}
}

export class BlogImageProfileResponseModel {
  constructor(
    public success: boolean,
    public message: string,
    public path: string,
    public imageName: string
  ) {}
}

export class BlogCreatePostResponseModel {
  constructor(public success: boolean) {}
}
